import api from '../config/api';

// Uploads a File/Blob to the shared /files/upload endpoint and returns the
// stored file URL string (the value the API expects in fields like
// attendance.fileIn / fileOut, order attachments, etc.).
export async function uploadFile(file) {
	if (!file) {
		return '';
	}

	const safeName = (file.name || 'upload').replace(/\s/g, '_');
	const normalizedFile =
		file instanceof File ? new File([file], safeName, { type: file.type }) : file;

	const formData = new FormData();
	formData.append('file', normalizedFile);

	// Let axios set the multipart boundary; the api interceptor adds the token.
	const response = await api.post('/files/upload', formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});

	return response.data?.fileUrl || '';
}
